<template>
	<div class="modal-wrapper">
		<div class="modal-container">
			<div class="modal">
				<div class="title-container">
					<div class="title">Details</div>
					<div class="buttons">
						<a href @click.prevent="$emit('cancel')" class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></a>
					</div>
				</div>
				<div v-if="loading" class="loader inline"><img src="/images/spinner.svg" class="fa fa-spin spinner" aria-hidden="true"></div>
				<div v-for="field in (loading ? [] : visibleFields)" :key="`v_${field.id}`" class="input-container">
					<div class="input-title">{{ field.name }}</div>
					<div class="input-static-text">
						<component
							:field="field"
							:row="row"
							:module="moduleData.module"
							:tags="moduleData.tags['v_' + field.id] || []"
							:options="moduleData.associatedModules['v_' + field.id] || []"
							:is="getFieldComponent(field)"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import _ from 'underscore';
import * as Fields from '../components/fields/Details';
import CrudDetails from '@/mixins/CrudDetails';

export default {

	props: [ 'moduleSlug', 'id' ],

	mixins: [CrudDetails],

	data() {
		return {
			loading: false,
			row: {},
			associatedModules: {},
			tags: {},
			module: {},
		};
	},

	mounted() {
		this.loadData();
	},

	methods: {

		async loadData() {
			this.loading = true;

			try {
				const url = `/module/${this.moduleSlug}/${this.id}/edit`;
				const { data } = await this.$api.get(url);
				this.setData(data);
			} catch(e) {
				this.$store.dispatch('errorToast', 'Unable to load details');
			}

			this.loading = false;
		},

		setData({ module, tags, associatedModules, row }) {
			this.row = row;

			this.moduleData = {
				module, tags, associatedModules
			};

			this.module = module;

			this.associatedModules = associatedModules;
			this.tags = tags;

			this.$nextTick(() => this.loaded = true);
		},

		/**
		 * Get the Output component for this field (based on field type)
		 *
		 * @param field
		 * @returns {*}
		 */
		getFieldComponent(field) {
			if (typeof Fields[ field.type ] !== 'undefined') {
				return Fields[ field.type ];
			}

			return Fields[ 'string' ];
		},

	},
};

</script>
